export const reportSettings = {
    1: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    2: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    3: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    6: {
        frequency: false,
        weekday: true,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    4: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: true,
        topics: true,
        keywords: false,
        customDashboard: false,
    },
    5: {
        frequency: false,
        weekday: true,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: true,
        topics: true,
        keywords: false,
        customDashboard: false,
    },
    7: {
        frequency: false,
        weekday: true,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    30: {
        frequency: false,
        weekday: false,
        monthday: true,
        dateRange: false,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    0: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: true,
        locations: true,
        platforms: true,
        languages: false,
        topics: true,
        keywords: true,
        customDashboard: false,
    },
    10: {
        frequency: true,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: false,
        platforms: false,
        languages: false,
        topics: false,
        keywords: false,
        customDashboard: true,
    },
    9: {
        frequency: false,
        weekday: false,
        monthday: false,
        dateRange: false,
        locations: true,
        platforms: false,
        languages: false,
        topics: false,
        keywords: false,
        customDashboard: false,
    },
};

export const deliveryTimeOptions = [
    { value: "00:00:00", label: "00:00:00" },
    { value: "00:30:00", label: "00:30:00" },
    { value: "01:00:00", label: "01:00:00" },
    { value: "01:30:00", label: "01:30:00" },
    { value: "02:00:00", label: "02:00:00" },
    { value: "02:30:00", label: "02:30:00" },
    { value: "03:00:00", label: "03:00:00" },
    { value: "03:30:00", label: "03:30:00" },
    { value: "04:00:00", label: "04:00:00" },
    { value: "04:30:00", label: "04:30:00" },
    { value: "05:00:00", label: "05:00:00" },
    { value: "05:30:00", label: "05:30:00" },
    { value: "06:00:00", label: "06:00:00" },
    { value: "06:30:00", label: "06:30:00" },
    { value: "07:00:00", label: "07:00:00" },
    { value: "07:30:00", label: "07:30:00" },
    { value: "08:00:00", label: "08:00:00" },
    { value: "08:30:00", label: "08:30:00" },
    { value: "09:00:00", label: "09:00:00" },
    { value: "09:30:00", label: "09:30:00" },
    { value: "10:00:00", label: "10:00:00" },
    { value: "10:30:00", label: "10:30:00" },
    { value: "11:00:00", label: "11:00:00" },
    { value: "11:30:00", label: "11:30:00" },
    { value: "12:00:00", label: "12:00:00" },
    { value: "12:30:00", label: "12:30:00" },
    { value: "13:00:00", label: "13:00:00" },
    { value: "13:30:00", label: "13:30:00" },
    { value: "14:00:00", label: "14:00:00" },
    { value: "14:30:00", label: "14:30:00" },
    { value: "15:00:00", label: "15:00:00" },
    { value: "15:30:00", label: "15:30:00" },
    { value: "16:00:00", label: "16:00:00" },
    { value: "16:30:00", label: "16:30:00" },
    { value: "17:00:00", label: "17:00:00" },
    { value: "17:30:00", label: "17:30:00" },
    { value: "18:00:00", label: "18:00:00" },
    { value: "18:30:00", label: "18:30:00" },
    { value: "19:00:00", label: "19:00:00" },
    { value: "19:30:00", label: "19:30:00" },
    { value: "20:00:00", label: "20:00:00" },
    { value: "20:30:00", label: "20:30:00" },
    { value: "21:00:00", label: "21:00:00" },
    { value: "21:30:00", label: "21:30:00" },
    { value: "22:00:00", label: "22:00:00" },
    { value: "22:30:00", label: "22:30:00" },
    { value: "23:00:00", label: "23:00:00" },
    { value: "23:30:00", label: "23:30:00" },
];

export const weekdayOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
];

export const frequencyOptions = [
    { value: "Daily", label: "Daily" },
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" },
];

export const monthdayOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
];

export const getReportEditTime = (time, user_timezone) => {
    let temp_time = time;
    let temp_date = new Date("2020/12/21 " + temp_time + ""); // the constant date is just as a constant for creating the data.
    let unixtime = temp_date.getTime();
    let curr_time = unixtime + user_timezone * 60 * 60 * 1000;
    let d = new Date();
    d.setTime(curr_time);
    let edit_email_scheduled_time = "";
    if (d.getHours() == 0) edit_email_scheduled_time = "00";
    else if (d.getHours() < 10) edit_email_scheduled_time = "0" + d.getHours();
    else edit_email_scheduled_time = d.getHours();
    if (d.getMinutes() == 10) edit_email_scheduled_time = edit_email_scheduled_time + ":00:00";
    else if (d.getMinutes() < 10) edit_email_scheduled_time = edit_email_scheduled_time + ":0" + d.getMinutes() + ":00";
    else edit_email_scheduled_time = edit_email_scheduled_time + ":" + d.getMinutes() + ":00";
    // console.log(edit_email_scheduled_time, time);
    return deliveryTimeOptions.filter((r) => r.value === edit_email_scheduled_time)[0];
};

export const getReportUTCTime = (time, user_timezone) => {
    let temp_time = time;
    let temp_date = new Date("2020/12/21 " + temp_time + ""); // the constant date is just as a constant for creating the data.
    let unixtime = temp_date.getTime();
    let curr_time = unixtime - user_timezone * 60 * 60 * 1000;
    let d = new Date();
    d.setTime(curr_time);
    let edit_email_scheduled_time = "";
    if (d.getHours() == 0) edit_email_scheduled_time = "00";
    else if (d.getHours() < 10) edit_email_scheduled_time = "0" + d.getHours();
    else edit_email_scheduled_time = d.getHours();
    if (d.getMinutes() == 10) edit_email_scheduled_time = edit_email_scheduled_time + ":00:00";
    else if (d.getMinutes() < 10) edit_email_scheduled_time = edit_email_scheduled_time + ":0" + d.getMinutes() + ":00";
    else edit_email_scheduled_time = edit_email_scheduled_time + ":" + d.getMinutes() + ":00";
    // console.log(edit_email_scheduled_time, time);
    return edit_email_scheduled_time;
};
